import styled from 'styled-components';

export const Copy = styled.p`
  margin: 0;
  font-size: ${(props) => props.theme.fonts.copy.size};
  line-height: 18px;
`;

export const Title = styled.h1`
  margin: 0;
  color: ${(props) => props.theme.colors.text};
  font-size: ${(props) => props.theme.fonts.h1.size};
  font-style: bold;
`;
